import React from 'react';

const InfoPage = ({ onClose }) => {
  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div
      className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-11/12 relative text-gray-800 font-open-sans"
      onClick={handleContentClick}
    >
      <button
        onClick={onClose}
        className="absolute top-3 right-3 p-1 rounded-full hover:bg-gray-200"
        aria-label="Info schließen"
      >
        <svg className="h-6 w-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <h3 className="text-2xl font-bold mb-4">Lust auf mehr?</h3>
      <div className="space-y-3 text-base">
        <p>
          Dann wirf doch einen Blick ins Buch! Mehr Illustrationen, längere Kapitel und neue Quizfragen.
        </p>
        <p>
          Marie und die Geldanlage basiert auf dem gleichnamigen Buch von der Autorin Rosa-Maria Krämer und vermittelt Kindern ein Grundwissen über Geld als Tauschmittel, den Euro und die Zentralbanken.
        </p>
        <div className="flex justify-center pt-4">
          <a
            href="https://amzn.eu/d/3urxdqZ"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-3 rounded-full transition-colors shadow-md font-open-sans bg-yellow-400 text-gray-900 hover:bg-yellow-500 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50 pointer-events-auto font-bold"
          >
            Buch auf Amazon
          </a>
        </div>
      </div>
    </div>
  );
};

export default InfoPage;